export default __webpack_public_path__ + "static/invoice-view-history-76f5494b0d1d26a4e823edae76795292.png";